import { useState, useEffect } from "react";

export function usePlaylist(email) {
  const [temp, setTemp] = useState([]);
  const [current, setCurrent] = useState([]);
  const [mySongs, setMySongs] = useState([]);

    const isLocal = window.location.hostname === "localhost";
  const API_URL = isLocal ? "http://localhost:5000/api" // backend local sans /api 
    : "/api"; // backend prod avec /api

  async function loadMySongs() {
    const res = await fetch(`${API_URL}/playlist/guest?email=${email}`);
    const data = await res.json();
    setMySongs(data);

// console.log("RAW response:", res); 
// console.log("Parsed JSON:", data); 
// console.log("Type of data:", typeof data); 
// console.log("Is array:", Array.isArray(data));

    return data; // 🔥 important
  }

  async function loadCurrentPlaylist() {
    const res = await fetch(`${API_URL}/playlist/current`);
    const data = await res.json();
    setCurrent(data);
  }
  
async function loadTemp() {
  const res = await fetch(`${API_URL}/playlist/temp?email=${email}`);
  const data = await res.json();
  setTemp(data);
  return data; // 🔥 important
}

  async function syncTemp(newTemp) {
    setTemp(newTemp);

    await fetch(`${API_URL}/playlist/temp-select`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email,
        songs: newTemp
      })
    });
  }
  
  function addTemp(song) {
    if (temp.length >= 2) return;
    if (temp.find(s => s.id === song.id)) return;

    const newTemp = [...temp, song];
    syncTemp(newTemp);
  }

  function removeTemp(id) {
    const newTemp = temp.filter(s => s.id !== id);
    syncTemp(newTemp);
  }

  async function validate() {
    console.log("email envoyée:", email);
    const res = await fetch(`${API_URL}/playlist/validate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email })
    });

    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.error);
    }

    setTemp([]);
     await loadCurrentPlaylist();
     const validated = await loadMySongs(); // on récupère les choix validés
      await loadTemp();
      
      // 🔥 Réinitialiser temp avec les choix validés 
      setTemp(validated.map(s => ({ ...s, isTemp: false })));
  }

  function areSameChoices(a, b) {
  if (a.length !== b.length) return false;
  const idsA = a.map(s => s.id).sort();
  const idsB = b.map(s => s.id).sort();
  return JSON.stringify(idsA) === JSON.stringify(idsB);
}


  // 🔥 Initialisation : temp = tempSongs || mySongs
  useEffect(() => {
    async function init() {
     await loadCurrentPlaylist();
     const mySongs = await loadMySongs(); 
     const temp = await loadTemp();

      // console.log("tempSongs chargées:", temp);
      // console.log("mySongs chargées:", mySongs);
      // Si pas de tempSongs, on initialise temp avec les choix validés
      if ((temp === undefined || temp.length === 0) && mySongs.length > 0) {
        const initialTemp = mySongs.map(s => ({ ...s, isTemp: false }));
        await syncTemp(initialTemp); // 🔥 met à jour le backend
      }
    }

    init();
  }, []);

  return {
    temp,
    current,
    mySongs,
    addTemp,
    removeTemp,
    validate, 
    areSameChoices
  };
}


    // playlist,

  // return {
  //   searchLocal,
  //   searchDeezer,
  //   temp,
  //   addTemp,
  //   removeTemp,
  //   validate
  // };


  // return { songs, loading, selectSong, unselectSong };

  // async function load() {
  //   setLoading(true);
  //   const res = await fetch(`${API_URL}/playlist`);
  //   const data = await res.json();
  //   setSongs(data);
  //   setLoading(false);
  // }

  // async function selectSong(songId) {
  //   const res = await fetch(`${API_URL}/playlist/select`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({ email, songId })
  //   });

  //   if (!res.ok) {
  //     const err = await res.json();
  //     throw new Error(err.error);
  //   }

  //   await load();
  // }

  // async function unselectSong(songId) {
  //   const res = await fetch(`${API_URL}/playlist/unselect`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({ email, songId })
  //   });

  //   if (!res.ok) {
  //     const err = await res.json();
  //     throw new Error(err.error);
  //   }

  //   await load();
  // }

  // useEffect(() => {
  //   load();
  // }, []);

  // const [songs, setSongs] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const [playlist, setPlaylist] = useState([]);

  
  
  // async function loadPlaylist() {
  //   const res = await fetch("/playlist");
  //   const data = await res.json();
  //   setPlaylist(data);
  // }

  // async function searchLocal(query) {
  //   const res = await fetch(`${API_URL}/songs/search?query=${query}`);
  //   return await res.json();
  // }

  // async function searchDeezer(query) {
  //   const res = await fetch(`${API_URL}/songs/deezer?query=${query}`);
  //   return await res.json();
  // }


  // function addTemp(song) {
  //   if (temp.length >= 2) return;
  //   if (temp.find(s => s.id === song.id)) return;
  //   setTemp([...temp, song]);
  // }

  // function removeTemp(id) {
  //   setTemp(temp.filter(s => s.id !== id));
  // }